export default __webpack_public_path__ + "static/media/video-scrub.35c89453.mp4";